import { createAction } from "@ngrx/store";
import { createCachedGetAction, createGetSuccessAction } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

const ACTION_PREFIX = "[Nationality]";
export const NATIONALITY_ACTION_TYPE = {
	getAll: `${ACTION_PREFIX} Get All`,
	getAllSuccess: `${ACTION_PREFIX} Get Success`,
	getAllFail: `${ACTION_PREFIX} Get AllFail`,
};

/**
 * @deprecated [fabric-deprecated] - use fabric ContentService from svc-content instead
 */
export namespace NationalityAction {
	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentServiceValue.GetAllNationalities)" instead
	 */
	export const getAll = createCachedGetAction(createAction(NATIONALITY_ACTION_TYPE.getAll));

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentServiceValue.GetAllNationalities)" instead
	 */
	export const getAllSuccess = createGetSuccessAction(
		createAction(NATIONALITY_ACTION_TYPE.getAllSuccess, (nationalities: Record<string, string>) => ({
			nationalities,
		}))
	);

	/**
	 * @deprecated [fabric-deprecated] - Use "document.obgEventBus.retrieve(ContentServiceValue.GetAllNationalities)" instead
	 */
	export const getAllFail = createAction(NATIONALITY_ACTION_TYPE.getAllFail, (error: AppError) => ({ error }));
}
